import type { PanelProps } from "../panel-props"

import { SCORE_STORAGE_KEY } from "../../../dont-hit-it/config"
import { IS_AUTH } from "../../../modules/auth"
import { useSettings } from "../../../modules/settings"
import { Button } from "../../button"
import { Select } from "../../select"
import { Slider } from "../../slider"
import { toast } from "../../ui/toast"
import { SharedSettings } from "../shared-settings"

const COUNT_OPTIONS = [
  { key: "1", label: "1" },
  { key: "2", label: "2" },
  { key: "3", label: "3" },
]

const SOURCE_OPTIONS = [
  { key: "bookmarks", label: "bookmarks" },
  { key: "core bookmarks", label: "core bookmarks" },
  { key: "pair of word", label: "pair of word" },
]

const MAX_NUMBER_OF_QUESTIONS = {
  max: 60,
  min: 20,
  step: 5,
}
export function DontHitItSettings({ closeSidebar }: PanelProps) {
  const { appSettings, setAppSettings } = useSettings()

  const onChangeCount = (value: string)=> {
    setAppSettings("count", Number(value), "dontHitIt")
  }

  const onChangeSource = (value: string)=> {
    setAppSettings("source", value, "dontHitIt")
  }

  const onMaxNumberOfQuestionsChange = (value: number)=> {
    setAppSettings("maxNumberOfQuestions", value, "dontHitIt")
  }

  const clearScores = ()=> {
    localStorage.removeItem(SCORE_STORAGE_KEY)
    toast.success("Scores cleared")
  }

  return (
    <SharedSettings closeSidebar={closeSidebar}>
      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Source</h3>
        {IS_AUTH && (
          <Select
            initialValue={appSettings.dontHitIt.source}
            label="Source"
            onChange={onChangeSource}
            options={SOURCE_OPTIONS}
          />
        )}
        <Select
          initialValue={String(appSettings.dontHitIt.count)}
          label="Don't Hit words"
          onChange={onChangeCount}
          options={COUNT_OPTIONS}
        />
      </section>

      <div className="sidebar__separator" role="separator" />

      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Limits</h3>
        <Slider
          label="Max number of questions"
          max={MAX_NUMBER_OF_QUESTIONS.max}
          min={MAX_NUMBER_OF_QUESTIONS.min}
          navigation={{ step: 5 }}
          onValueChange={onMaxNumberOfQuestionsChange}
          step={MAX_NUMBER_OF_QUESTIONS.step}
          value={appSettings.dontHitIt.maxNumberOfQuestions}
        />
      </section>

      <div className="sidebar__separator" role="separator" />

      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Actions</h3>
        <Button onClick={clearScores} variant="destructive">
          clear all scores
        </Button>
      </section>
    </SharedSettings>
  )
}
